import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { CobradorMinvuDto } from "../models/modelsCobradorMinvu";

const crearMinvuCobro = async (data: CobradorMinvuDto[]) => {
      const items = {
        items: data
    }
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-dividendos/v1/minvu/crear-minvu-cobro`, items);
    return response;
}

export { crearMinvuCobro }